import { useEffect, useState } from 'react';
import { ChatIcon, MailIcon } from '../Icons';
import './styles.scss';

type Props = {
  positionRef: React.RefObject<HTMLDivElement | null>;
  onGetTheDeckClick: () => void;
};

const phoneNumber = '+60108004974';

export const CtaButtons = ({ positionRef, onGetTheDeckClick }: Props) => {
  const [isFixed, setIsFixed] = useState(true);

  useEffect(() => {
    const element = positionRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsFixed(!entry?.isIntersecting);
      },
      {
        threshold: 0.1,
      }
    );

    observer.observe(element);

    return () => {
      observer.unobserve(element);
    };
  }, []);

  return (
    <div className={['cta-buttons', isFixed ? 'fixed' : 'sticky'].join(' ')}>
      <div className='buttons'>
        <div className='button-left'>
          <button
            className='button'
            onClick={() => {
              window.open(`https://wa.me/${phoneNumber}`, '_blank');
            }}
          >
            <ChatIcon />
            <span>Contact us</span>
          </button>
        </div>
        <div className='button-right'>
          <button className='button' onClick={onGetTheDeckClick}>
            <MailIcon />
            <span>Get the deck</span>
          </button>
        </div>
      </div>
    </div>
  );
};
